import React from 'react';
import styled from 'styled-components';
import { Table } from 'antd';
export const CustomFilterDropdownIconTable = styled(Table) `
  th.ant-table-column-has-sorters:hover {
    background: #fafafa !important;
  }
  th.ant-table-selection-column:hover {
    background-color: #e6f7ff !important;
    cursor: pointer;
  }
`;
export const TableFullRowSelect = (args) => {
    const { onRow, rowSelection, rowKey = 'key', ...props } = args;
    const { selectedRowKeys, onChange, onSelectAll, onSelect } = rowSelection;
    // Override the onRow function to return a new set of events with a custom wrapper for onClick to handle
    // clicking the column to trigger the checkbox
    const rowConfig = (record, index) => ({
        onClick: (event) => {
            var _a, _b, _c;
            const target = event.target;
            if ((_a = target.getAttribute('class')) === null || _a === void 0 ? void 0 : _a.includes('ant-table-selection')) {
                let rowKeys = [];
                let selected = false;
                event.preventDefault();
                if (selectedRowKeys.includes(record[rowKey])) {
                    rowKeys = selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys.filter((key) => key !== record[rowKey]);
                }
                else {
                    rowKeys = selectedRowKeys.concat([record[rowKey]]);
                    selected = true;
                }
                onChange(rowKeys);
                onSelect &&
                    onSelect(record, selected, props.dataSource.filter(r => rowKeys.includes(r[rowKey])));
            }
            else {
                onRow && ((_c = (_b = onRow(record, index)) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.call(_b, event));
            }
        },
        // Fill out the rest of the supported events
        onDoubleClick: (arg) => {
            var _a, _b;
            onRow && ((_b = (_a = onRow(record, index)) === null || _a === void 0 ? void 0 : _a.onDoubleClick) === null || _b === void 0 ? void 0 : _b.call(_a, arg));
        },
        onContextMenu: (arg) => {
            var _a, _b;
            onRow && ((_b = (_a = onRow(record, index)) === null || _a === void 0 ? void 0 : _a.onContextMenu) === null || _b === void 0 ? void 0 : _b.call(_a, arg));
        },
        onMouseEnter: (arg) => {
            var _a, _b;
            onRow && ((_b = (_a = onRow(record, index)) === null || _a === void 0 ? void 0 : _a.onMouseEnter) === null || _b === void 0 ? void 0 : _b.call(_a, arg));
        },
        onMouseLeave: (arg) => {
            var _a, _b;
            onRow && ((_b = (_a = onRow(record, index)) === null || _a === void 0 ? void 0 : _a.onMouseLeave) === null || _b === void 0 ? void 0 : _b.call(_a, arg));
        }
    });
    const headerConfig = (record, index) => ({
        onClick: (arg) => {
            var _a;
            const target = arg.target;
            if ((_a = target.getAttribute('class')) === null || _a === void 0 ? void 0 : _a.includes('ant-table-selection')) {
                arg.preventDefault();
                let rowKeys = [];
                let selected = false;
                if (selectedRowKeys.length !== props.dataSource.length) {
                    rowKeys = props.dataSource.map((data) => data[rowKey]);
                    selected = true;
                }
                onChange(rowKeys);
                onSelectAll &&
                    onSelectAll(selected, props.dataSource, props.dataSource.filter(r => !selectedRowKeys.includes(r[rowKey])));
            }
        }
    });
    const tableProps = {
        onHeaderRow: headerConfig,
        onRow: rowConfig,
        rowSelection,
        rowKey,
        ...props
    };
    return React.createElement(CustomFilterDropdownIconTable, { ...tableProps });
};
